import React from "react";
import { PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const PageHeaderTopTitle = ({ topTitle }) => {
    return (React.createElement(PeekButton, { onClick: topTitle.onClick, sx: { width: "fit-content", marginLeft: -1, opacity: 0.7 } },
        React.createElement(PeekStack, { direction: "row", alignItems: "center", gap: 0.5 },
            React.createElement(PeekTypography, { variant: "h3", lineHeight: "10px" }, topTitle.icon),
            React.createElement(PeekTypography, { variant: "h3" }, topTitle.label))));
};
export default PageHeaderTopTitle;
